import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import UserBox from 'components/UserBox';
import ResendCodeButtons from './components/ResendCodeButtons';
import { type MultiFactorAuthFormFields } from './types';
import MultiFactorAuthForm from './components/MultiFactorAuthForm';

export const MultiFactorAuth = () => {
  const methods = useForm<MultiFactorAuthFormFields>();

  return (
    <UserBox id="loginBox" className="userBox--white loginBox" overScroll>
      <div className="loginBox__headingContainer">
        <h3 className="loginBox__heading">Log in to MrQ</h3>
      </div>
      <FormProvider {...methods}>
        <MultiFactorAuthForm />
        <ResendCodeButtons />
      </FormProvider>
    </UserBox>
  );
};
